export const calculateHeightToBottom = (element) => {
  const elementTop = element.getBoundingClientRect().top;
  const viewportHeight = window.innerHeight;

  const heightToBottom = viewportHeight - elementTop;

  return heightToBottom;
};

export const typeCharacters = (element, text, delay = 50) => {
  let index = 0;

  if (!element) return;

  element.focus();

  const typeNextCharacter = () => {
    if (index < text.length) {
      element.value += text[index];
      element.dispatchEvent(new Event('input', { bubbles: true }));

      index++;

      setTimeout(typeNextCharacter, delay);
    }
  };

  typeNextCharacter();
};
